import { BaseModel } from '../classes/base-model';
import { Event } from './event';
import { PerformancePerformer } from './performance-performer';
import { PerformanceProduct } from './performance-product';
import { PerformanceStatus } from './performance-status.enum';
import { Product } from './product';
import { ReservationExpirationType } from './reservation-expiration-type.enum';
import { Template } from './template';

export class Performance extends BaseModel {
 	IsArchive: boolean;
    CategoryId: number;
    VenueTemplateId: number;
    Status: PerformanceStatus;
    PublishDate: string;
    SalesBeginDate: string;
    SalesEndDate: string;
    Code: string;
    Date: string;
    EndDate: string;
    IsEnabled: boolean;
    PurchaseTimeSeconds: number;
    IsSeason: boolean;
    SeasonalPerformanceId: number;
    Images: string;
    PrintTicketBandImage: string;
    ReservationAvailable: boolean;
    ReservationExpirationType: ReservationExpirationType;
    ReservationExpirationTime: number;
    SuspensionReason: string;
    CancellationReason: string;
    IsAccessIntegrationActive: boolean;
    IsTicketForwardingAvailable: boolean;
    IsGenerateBarcodeAvailable: boolean;
    MaxMemberLimit:number;
    IsCombinedTicketResale:boolean;
    IsCombinedCancellable:boolean;
    CombinedCancellationDuration:number;
    AccessIntegrationTypeId: number;
    NoExpire: boolean;
    ExpirationType: number;
    ExpirationDate: string;
    EventId: number;
    IsInviteFriendAvailable: boolean;
    InviteFriendExpirationType: ReservationExpirationType;
    InviteFriendExpirationTime: number;
    IsBundle: boolean;
    Id: number;
    PerformanceName: string;
    VenueTemplate: Template;
    Localization: {
        Name?: string;
        Description?: string;
        Tr?: {
          Name?: string;
          ShortName?: string;
          Description?: string;
          StatusText?: string
        },
        En?: {
          Name?: string;
          ShortName?: string;
          Description?: string;
          StatusText?: string
        }
	};
  Products?:PerformanceProduct[];
  Event?: Event;
  PerformancePerformers?: PerformancePerformer[];
  SGMSeanceId?: number;
  MovieVersionName?: string;
  CombinePerformance?:{ 
    CombinePerformanceId?: number;
    CombinePerformanceLocalization?: {
      Tr?: {
        Name?: string;
        ShortName?: string;
        Description?: string;
        StatusText?: string;
      };
      En?: {
        Name?: string;
        ShortName?: string;
        Description?: string;
        StatusText?: string;
      };
    };}
}



// WEBPACK FOOTER //
// ./src/app/models/performance.ts